import Vue from 'vue'
import VueI18n from 'vue-i18n'


Vue.use(VueI18n);

// Escapes a text so it can be inserted as HTML
function escape_html(value) {
    return String(value).replace(/[&<>"']/g, char => ({"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"}[char]));
}

// Translates a key and returns HTML for v-html. Texts of the language files may contain HTML (<br>, <strong>, ...).
// Everything that does not come from a language file is escaped: a string that is not a translation key (for example a
// raw server message) and the values that are inserted into a text, so user provided content can never inject markup.
// Escapes arbitrary user-typed content (post descriptions, comments, ...) before it is handed to a component
// that renders its input as HTML internally (for example vue-read-more), so no markup a user typed can execute
Vue.prototype.$escape_html = escape_html;

Vue.prototype.$th = function (key, values) {
    const fallback = this.$i18n.fallbackLocale;
    const exists   = typeof key === "string" && (this.$te(key) || (typeof fallback === "string" && this.$te(key, fallback)));
    if (!exists)
        return escape_html(key === undefined || key === null ? "" : key);

    const safe_values = {};
    Object.keys(values || {}).forEach(name => safe_values[name] = typeof values[name] === "string" ? escape_html(values[name]) : values[name]);

    // Arrays and objects are no texts, a key that is only echoed back means the text is empty
    const text = this.$t(key, safe_values);
    return typeof text === "string" && text !== key ? text : "";
};

function loadLocaleMessages() {
    const locales  = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale     = matched[1];
            messages[locale] = locales(key)
        }
    });
    return messages
}

const messages = loadLocaleMessages();

// Every language code that actually has a file in ./locales, in no particular order. The language switcher uses
// this so a new locale file shows up there on its own, without touching the switcher itself.
export const available_locales = Object.keys(messages);

// The primary subtag of a BCP-47 tag ("de-DE" -> "de", "pt-BR" -> "pt"), lowercased.
function primary_subtag(tag) {
    return typeof tag === "string" ? tag.split("-")[0].toLowerCase() : "";
}

// The language to start with when nothing was chosen yet (no saved preference, no logged-in account): the first of
// the browser's preferred languages that we actually have a translation for, otherwise English.
export function detect_browser_locale() {
    const preferences = (typeof navigator !== "undefined" && (navigator.languages || [navigator.language])) || [];
    const match        = preferences.map(primary_subtag).find(tag => available_locales.includes(tag));

    return match || 'en';
}

export default new VueI18n({
    locale               : process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale       : process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages             : messages,
    silentTranslationWarn: true
})
